export default "__VITE_ASSET__2d931995__"